// Public export surface for Relentless-DS
// Components
export { default as Button } from "./components/Button";
export { default as Badge } from "./components/Badge";
export { default as ToolTip } from "./components/ToolTip";
export { default as Tooltip } from "./components/ToolTip";
export { default as Chip } from "./components/chips";
export { default as Accordion } from "./components/Accordion";
export { default as Modal } from "./components/Modal";
export { default as ProfileCard } from "./components/profileCard";
export { default as ArticleCard } from "./components/article-card";
export { default as SocialArticleCard } from "./components/SocialArticleCard";
export { default as DataCard } from "./components/DataCard";
export { default as MetricCard } from "./components/MetricCard";
export { default as Slider } from "./components/Slider";
export { default as DataTable } from "./components/Table";
export { default as Calendar } from "./components/Calendar";
export { default as NavBar } from "./components/NavBar";
export { default as Tabs } from "./components/Tabs";
export { default as Breadcrumb } from "./components/Breadcrumb";
export { default as Pagination } from "./components/Pagination";
export { default as Notification } from "./components/Notification";
export { default as HeroBanner } from "./components/HeroBanner";
export { default as Testimonials } from "./components/Testimonials";
export { default as PhotoGrid } from "./components/PhotoGrid";
export { default as MenuItem } from "./components/MenuItem";
export { default as FilterBar } from "./components/FilterBar";
export { default as Login } from "./components/Login";
export { default as SignUp } from "./components/SignUp";
export { default as Footer } from "./components/Footer";
export { default as Logo } from "./components/Logo";
export { default as SocialIcon } from "./components/SocialIcon";
export { default as AudioPlayer } from "./components/AudioPlayer";
export { default as Carousel } from "./components/Carousel";
export { useCarousel } from "./components/Carousel";
export { default as SectionHeader } from "./components/section-header";
export { default as Section } from "./components/section";
export { default as Loader } from "./components/Loader";

// Layouts
export { default as AppShell } from "./components/layouts/AppShell";
export { default as DashboardHeader } from "./components/layouts/DashboardHeader";
export { default as DashboardShell } from "./components/layouts/DashboardShell";
export { default as AuthLayout } from "./components/layouts/AuthLayout";
export { default as CenteredLayout } from "./components/layouts/CenteredLayout";

// Inputs (named exports)
export {
  RadioButtons,
  Checkbox,
  ToggleSwitch,
  TextInput,
  DropDown,
} from "./components/Inputs";

// Theme toggler helper
export { default as ThemeToggle } from "./theme";
export {
  applyTheme,
  initDesignTokens,
  applyResponsiveDimensions,
  initResponsiveDimensions,
} from "./theme";

// Styles note: consumers should import CSS separately, e.g.:
// import 'relentless-ds/dist/variables.css';
// import 'relentless-ds/dist/relentless.min.css';

// Dev-only: if this repo is run via CRA dev server,
// mount the demo App so you can interact with components.
if (typeof document !== "undefined" && !process.env.RM_DS_LIB_BUILD) {
  const rootEl = document.getElementById("root");
  if (rootEl) {
    // Ensure a default theme so CSS variables resolve
    if (!document.documentElement.getAttribute("data-theme")) {
      document.documentElement.setAttribute("data-theme", "light");
    }

    Promise.all([
      import("./styles/variables.css"),
      import("./styles/index.scss"),
      import("react"),
      import("react-dom/client"),
      import("./App"),
    ])
      .then(([, , /*css1*/ /*css2*/ ReactMod, ReactDOMClient, AppMod]) => {
        const React = ReactMod.default || ReactMod;
        const { createRoot } = ReactDOMClient;
        const root = createRoot(rootEl);
        root.render(React.createElement(AppMod.default));
      })
      .catch(() => {
        // no-op if dev mount fails; library exports still work
      });
  }
}
